import Proptypes from 'prop-types';
import React from 'react';

const TransferAccount = ({ height = '32', width = '32' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.125 1.75H17.5V0.25H19.125V1.75ZM25.625 1.75H22.375V0.25H25.625V1.75ZM29.75 1.75H28.875V0.25H30.5C30.9142 0.25 31.25 0.585786 31.25 1V2.875H29.75V1.75ZM29.75 10.375V6.625H31.25V10.375H29.75ZM29.75 17.875V14.125H31.25V17.875H29.75ZM29.75 25.375V21.625H31.25V25.375H29.75ZM29.75 30.25V29.125H31.25V31C31.25 31.4142 30.9142 31.75 30.5 31.75H28.875V30.25H29.75ZM17.5 30.25H19.125V31.75H17.5V30.25ZM22.375 30.25H25.625V31.75H22.375V30.25Z"
      fill="#086EA1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5 31.2381C15.5 31.6589 15.1526 32 14.7241 32L1.27586 32C0.847362 32 0.499998 31.6589 0.499998 31.2381L0.5 0.761904C0.5 0.341116 0.847365 -1.19109e-06 1.27586 -1.15363e-06L14.7241 2.20521e-08C15.1526 5.95125e-08 15.5 0.341117 15.5 0.761905L15.5 31.2381ZM13.9483 30.4762L13.9483 1.52381L2.05172 1.52381L2.05172 30.4762L13.9483 30.4762Z"
      fill="#086EA1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.4615 12.513C24.3305 12.1201 23.9057 11.9077 23.5128 12.0387C23.1198 12.1697 22.9075 12.5944 23.0384 12.9874L23.7601 15.1522C22.2425 14.0333 19.778 13.0002 16.25 13.0002C10.8349 13.0002 7.32554 15.4264 6.18057 16.7622C5.911 17.0766 5.94743 17.5501 6.26192 17.8197C6.57641 18.0893 7.04989 18.0528 7.31946 17.7383C8.17449 16.7408 11.2651 14.5002 16.25 14.5002C20.3006 14.5002 22.6159 15.9746 23.614 17.005L20.5128 18.0387C20.1198 18.1697 19.9075 18.5944 20.0384 18.9874C20.1694 19.3803 20.5942 19.5927 20.9871 19.4617L25.4871 17.9617C25.8801 17.8307 26.0925 17.406 25.9615 17.013L24.4615 12.513Z"
      fill="#086EA1"
    />
  </svg>
);

TransferAccount.propTypes = {
  height: Proptypes.string,
  width: Proptypes.string,
};

export default TransferAccount;
